<template>
  <div class="exchange-i">
    <Header title="毕业设计" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="this.designReCodeList && this.designReCodeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="list-head" v-if="this.designReCodeList && this.designReCodeList.length > 0">
              <div>
                <p><label style=" font-family: PingFangSC-Medium;font-size: 16px;font-weight: bolder;">指导方式</label><span @click="showPop(valueList.label)">
                  <i>{{valueList.label}}</i>
                  <b></b>
                </span></p>
              </div>
             
            </div>
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of designReCodeList"
        :key="index"
        @click="toGuideal(item)"
      >
        <ul>
          <li><label>学生姓名：</label>{{ item.studentname }}</li>
          <li><label>设计（论文）题目：</label>{{ item.topicname }}</li>
          <li><label>提问内容：</label>{{ item.requstcontext }}</li>
          <li><label style="float:right">{{item.staute}}</label></li>
        </ul>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        title="指导方式"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(index);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      show:false,
      valueList: {
        label: "全部",
        value: "0",
        item: ""
      },
      zdlx:'0',
      columns:[{'text':'全部','value':'0'},{'text':'线下指导','value':'2'},{'text':'线上指导','value':'1'}],
      designReCodeList: [],
    };
  },
  methods: {
    showPop(label) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.item = this.columns;
    },
    onConfirm(index) {
      this.valueList.label = this.columns[index].text;
      this.valueList.value = this.columns[index].value;
      this.show = false;
      if(this.zdlx!=this.valueList.value){
        this.loadZdmsg(this.valueList.value);
        this.zdlx=this.valueList.value;
      }
    },
    async loadZdmsg(zdlx){
      const params = {
        type: zdlx,
      };
      const res = await Api.loadZdmsg(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
      }
    },
    toGuideal(item){
      if(item.type=='2'){
        this.$router.push({
          path: "/design/guideDeal_unload",
          query: {
            ywstid: item.sj110401id,
          }
        });
      }else{
        this.$router.push({
          path: "/design/guideDeal",
          query: {
            ywstid: item.sj110401id,
          }
        });
      }
      
    }
  },
  created() {
    this.loadZdmsg(0);
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 60px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding: 6% 7%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      
        span {
          
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            margin-left: 15px;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 80vh;
    .item {
      background: #f8f8f8;
      border-radius: 8px;
      margin: 0 auto 5%;
      padding: 3% 3% 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          font-family: PingFangSC-Light;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
          min-height: 16px;
        }

        li label {
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Design/design_wxzy.vue